import { render, staticRenderFns } from "./addVoters.vue?vue&type=template&id=42cb1f18&scoped=true&"
import script from "./addVoters.vue?vue&type=script&lang=js&"
export * from "./addVoters.vue?vue&type=script&lang=js&"
import style0 from "./addVoters.vue?vue&type=style&index=0&id=42cb1f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb1f18",
  null
  
)

export default component.exports